import clsx from "clsx";

import Spacer from "../Spacer";

interface ButtonProps {
  variant?: "primary" | "secondary" | "tertiary";
  size?: "large" | "small" | "medium";
  label?: string;
  onClick?: (arg: any) => void;
  type?: "button" | "submit";
  icon?: React.ReactNode;
  width?: number | string;
  height?: number | string;
  loading?: boolean;
  disabled?: boolean;
  textColor?: string;
  capitalized?: boolean;
  additionalClassname?: any;
  iconPosition?: "left" | "right";
  dataTestId?: string;
}

const ButtonSecondary: React.FC<ButtonProps> = ({
  variant,
  label,
  onClick = () => {},
  type = "button",
  icon,
  width,
  height,
  loading = false,
  disabled = false,
  textColor,
  capitalized,
  additionalClassname,
  size = "large",
  iconPosition = "left",
  dataTestId
}) => {
  const computedStyle = () => {
    const style: { width?: string; height?: string; color?: string } = {};

    if (width) {
      style.width = `${width}`;
    }

    if (height) {
      style.height = `${height}`;
    }

    if (textColor) {
      style.color = textColor;
    }

    return style;
  };

  return (
    <button
      data-testid={dataTestId}
      className={clsx({
        "flex items-center text-sm px-2 font-[400] justify-center rounded-[80px]":
          true,
        "bg-[#34623F] text-[#fff]": variant === "primary",
        "bg-[#fdfdfd]": variant && ["secondary", "tertiary"].includes(variant),
        "text-[#103C1B] border-[1px] border-solid border-[#34623F]":
          variant === "secondary",
        "border-[rgba(51, 51, 51, 0.1)]": variant === "tertiary",
        "opacity-50": disabled,
        "w-[299px] h-[40px]": size === "large",
        "w-[126px] h-[40px]": size === "medium",
        "w-[90px] h-[32px]": size === "small",
        capitalize: capitalized,
        [additionalClassname]: additionalClassname
      })}
      onClick={onClick}
      type={type}
      style={computedStyle()}
      disabled={disabled}
    >
      {icon && iconPosition === "left" && (
        <>
           {icon}
           <Spacer width={16} />
        </>
      )
      }
      {!loading ? <p className="">{label}</p> : "Loading..."}
      {icon && iconPosition === "right" && (
        <>
          <Spacer width={16} />
          {icon}
        </>
      )}
    </button>
  );
};

export default ButtonSecondary;
